import React from 'react';

interface AssetFileInputProps {
  fileInputRef: React.RefObject<HTMLInputElement>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AssetFileInput: React.FC<AssetFileInputProps> = ({ fileInputRef, onChange }) => (
  <input
    type="file"
    data-testid="file-upload-input"
    ref={fileInputRef}
    style={{ display: 'none' }}
    accept=".png,.jpg,.jpeg,.svg,.otf,.ttf"
    onChange={onChange}
  />
);

export default AssetFileInput;
